import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

const apiKey = process.env.REACT_APP_API_RETURNING_KEY;

const LogSearch = () => {
  const datesConfirmed = useSelector((state) => state.booking.datesConfirmed);
  const checkInDate = useSelector((state) => state.booking.checkInDate);
  const checkOutDate = useSelector((state) => state.booking.checkOutDate);
  const guest1Email = useSelector((state) => state.booking.guest1ReturningEmail);
  const guest2Email = useSelector((state) => state.booking.guest2ReturningEmail);

  const lastLoggedRef = useRef("");

// Format email string without commas
const formatEmailString = () => {
  if (guest1Email && guest2Email) return `Guest1 - ${guest1Email} | Guest2 - ${guest2Email}`;
  if (guest1Email) return `Guest1 - ${guest1Email}`;
  if (guest2Email) return `Guest2 - ${guest2Email}`;
  return "";
};

  const sendLog = () => {
  if (!checkInDate || !checkOutDate) return;

  const logKey = `${checkInDate}-${checkOutDate}-${guest1Email}-${guest2Email}`;
  if (lastLoggedRef.current === logKey) return;
  lastLoggedRef.current = logKey;

  const emailFormatted = formatEmailString(); // cleaned string

const payload = {
  arrivalDate: checkInDate,
  departureDate: checkOutDate,
  email: emailFormatted, // cleaned string
  timezone: (() => {
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return tz && typeof tz === "string" ? tz : "Unknown";
    } catch {
      return "Unknown";
    }
  })(),
  apiKey: apiKey,
};

  try {
    const json = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      const blob = new Blob([json], { type: "application/json" });
      navigator.sendBeacon("https://api.amitywellness.com/api-log-search.php", blob);
    } else {
      fetch("https://api.amitywellness.com/api-log-search.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(() => {});
    }
  } catch {
    // silent fail
  }
};

  useEffect(() => {

    if (datesConfirmed || guest1Email || guest2Email) {
      sendLog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datesConfirmed, guest1Email, guest2Email, checkInDate, checkOutDate]);

  return null;
};

export default LogSearch;
